import { c as _c } from "react/compiler-runtime";
import { Distribution, Donation, TaxYearlyReport, TaxYearlyReportUnits } from "../../../../../models";
import { GenericList } from "../GenericList";
import { ListRow } from "../GenericListRow";
import { TaxYearlyReportMobileDetails } from "./TaxYearlyReportMobileDetails";
import { TaxYearlyReportListBody } from "./TaxYearlyReportListBody";
import { TaxYearlyReportListSupplemental } from "./TaxYearlyReportListSupplemental";
import { AggregatedImpactTableConfiguration } from "../../../donations/DonationsAggregateImpactTable/DonationsAggregateImpactTable";
export const TaxYearlyReportMobileList: React.FC<{
  report: TaxYearlyReport;
  donations: Donation[];
  distribtionMap: Map<string, Distribution>;
  aggregateImpactConfig: AggregatedImpactTableConfiguration;
}> = t0 => {
  const $ = _c(29);
  const {
    report,
    donations,
    distribtionMap,
    aggregateImpactConfig
  } = t0;
  const t1 = report.units.length == 0 ? "Registrer en skatteenhet i fanen til venstre i menyen under \"skatt\" og alle donasjoner vil knyttes til den. Ta kontakt p\xE5 donasjon@gieffektivt.no om du \xF8nsker \xE5 knytte donasjonene dine til flere skatteenheter." : "Du har allerede en eller flere skatteenheter. Kontakt oss p\xE5 donasjon@gieffektivt.no for \xE5 knytte donasjonene dine til rett skatteenhet.";
  let t2;
  if ($[0] !== t1) {
    t2 = [{
      value: "Mangler enhet",
      tooltip: t1
    }];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== report.sumDonationsWithoutTaxUnit.channels) {
    t3 = report.sumDonationsWithoutTaxUnit.channels.filter(_temp);
    $[2] = report.sumDonationsWithoutTaxUnit.channels;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <TaxYearlyReportMobileDetails channels={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== report.sumDonationsWithoutTaxUnit || $[7] !== t2 || $[8] !== t4) {
    t5 = {
      id: "missingTaxUnits",
      defaultExpanded: false,
      cells: t2,
      details: t4,
      element: report.sumDonationsWithoutTaxUnit
    };
    $[6] = report.sumDonationsWithoutTaxUnit;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const rowMissingTaxUnits = t5;
  let rows;
  if ($[10] !== report.sumDonationsWithoutTaxUnit.sumDonations || $[11] !== report.units || $[12] !== rowMissingTaxUnits) {
    const rowsUnits = report.units.map(_temp2);
    rows = [...rowsUnits];
    if (report.sumDonationsWithoutTaxUnit.sumDonations > 0) {
      rows.push(rowMissingTaxUnits);
    }
    $[10] = report.sumDonationsWithoutTaxUnit.sumDonations;
    $[11] = report.units;
    $[12] = rowMissingTaxUnits;
    $[13] = rows;
  } else {
    rows = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div>Det mangler informasjon for skatteenheten.</div>;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div>{t6}<div>Ta kontakt på <a href="mailto: donasjon@gieffektivt.no">donasjon@gieffektivt.no</a>.</div></div>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const emptyPlaceholder = t7;
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [30, 60];
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== aggregateImpactConfig || $[19] !== distribtionMap || $[20] !== donations || $[21] !== report) {
    t10 = <TaxYearlyReportListSupplemental report={report} donations={donations} distribtionMap={distribtionMap} aggregateImpactConfig={aggregateImpactConfig} />;
    $[18] = aggregateImpactConfig;
    $[19] = distribtionMap;
    $[20] = donations;
    $[21] = report;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== report) {
    t11 = <TaxYearlyReportListBody report={report} />;
    $[23] = report;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== rows || $[26] !== t10 || $[27] !== t11) {
    t12 = <><GenericList title="" headers={t8} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={true} proportions={t9} supplementalInformation={t10} supplementalOnMobile={true} linedRows={true}>{t11}</GenericList></>;
    $[25] = rows;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(c) {
  return c.sumDonations > 0;
}
function _temp2(unit) {
  return {
    id: unit.id.toString(),
    defaultExpanded: false,
    cells: [{
      value: unit.name
    }],
    details: <TaxYearlyReportMobileDetails channels={unit.channels} unit={unit} />,
    element: unit
  };
}